import { render, staticRenderFns } from "./InitLoader.vue?vue&type=template&id=877fd58a&scoped=true&"
import script from "./InitLoader.vue?vue&type=script&lang=js&"
export * from "./InitLoader.vue?vue&type=script&lang=js&"
import style0 from "./InitLoader.vue?vue&type=style&index=0&id=877fd58a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877fd58a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
